export default "__VITE_ASSET__Dw6RJfOB__"